module.exports = __webpack_public_path__ + "assets/images/covid-hits-home-4.jpg?v=bf2e76dd";